interface SkeletonBlockProps {
  width?: string | number;
  height?: string | number;
  className?: string;
}

export function SkeletonBlock({ width = '100%', height = 16, className }: SkeletonBlockProps) {
  const cls = className ? `skeleton-block ${className}` : 'skeleton-block';
  return <div className={cls} style={{ width, height }} aria-hidden />;
}
